module.exports = __webpack_public_path__ + "img/investment_desktop_failed.c7be3776.svg";